var _circle, _circle2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJaShoulder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1165_8395",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 44,
    height: 44
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.0003,
    cy: 23.9998,
    r: 21.2571,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1165_8395)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.9427,
    cy: 20.2284,
    rx: 5.48571,
    ry: 5.48571,
    fill: "#EDF4FC"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(0.34202 0.939693 0.939693 -0.34202 38.9062 14.2998)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "matrix(0.906308 0.422618 0.422618 -0.906308 36.5059 13.6143)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4775,
    y: 12.9282,
    width: 1.37143,
    height: 3.42857,
    rx: 0.685714,
    transform: "rotate(160 35.4775 12.9282)",
    fill: "#5096E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4347 19.1956C37.5933 17.0078 35.2327 16.3546 33.1549 15.7786C30.263 14.9776 28.1732 14.4001 28.1732 10.2001C28.1732 10.041 28.11 9.88835 27.9974 9.77583C27.8848 9.66331 27.7322 9.6001 27.5729 9.6001C27.4137 9.6001 27.2611 9.66331 27.1485 9.77583C27.0359 9.88835 26.9727 10.041 26.9727 10.2001C26.9727 12.5176 27.5527 14.1001 28.7975 15.1733C29.8946 16.1198 31.3203 16.5158 32.8345 16.9351C36.8077 18.0353 41.3136 19.2818 41.3136 31.3771C41.3136 31.5362 41.3769 31.6888 41.4894 31.8014C41.602 31.9139 41.7547 31.9771 41.9139 31.9771C42.0731 31.9771 42.2258 31.9139 42.3384 31.8014C42.451 31.6888 42.5142 31.5362 42.5142 31.3771C42.5112 25.6396 41.505 21.6548 39.4347 19.1956Z",
    fill: "#536479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7664 9.60011C20.6072 9.60011 20.4545 9.66332 20.3419 9.77584C20.2293 9.88837 20.1661 10.041 20.1661 10.2001C20.1661 14.4001 18.0763 14.9754 15.1837 15.7764C13.1037 16.3524 10.7453 17.0056 8.90462 19.1934C6.83436 21.6526 5.82812 25.6374 5.82812 31.3748C5.82812 31.534 5.89137 31.6866 6.00395 31.7991C6.11652 31.9116 6.26921 31.9748 6.42842 31.9748C6.58762 31.9748 6.74031 31.9116 6.85289 31.7991C6.96546 31.6866 7.02871 31.534 7.02871 31.3748C7.02871 19.2796 11.5309 18.0331 15.5078 16.9329C17.0221 16.5136 18.4523 16.1176 19.5448 15.1734C20.7904 14.0979 21.3704 12.5176 21.3704 10.2001C21.3704 10.121 21.3548 10.0427 21.3244 9.96963C21.294 9.89659 21.2494 9.83028 21.1933 9.77451C21.1371 9.71875 21.0705 9.67463 20.9973 9.6447C20.924 9.61477 20.8455 9.59961 20.7664 9.60011Z",
    fill: "#536479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7742 24.9097C13.768 24.7506 13.6989 24.6004 13.5819 24.4923C13.465 24.3841 13.3098 24.3268 13.1506 24.333C12.9914 24.3391 12.8412 24.4083 12.733 24.5251C12.6248 24.642 12.5674 24.7971 12.5736 24.9562C12.5736 25.2315 13.0538 26.7847 13.6519 28.4107C13.489 29.007 12.8903 31.032 11.8758 32.6347C11.7916 32.769 11.764 32.9312 11.799 33.0857C11.834 33.2403 11.9288 33.3747 12.0626 33.4597C12.1969 33.5439 12.359 33.5716 12.5137 33.5368C12.6683 33.5019 12.8029 33.4074 12.888 33.2737C13.5356 32.2515 14.0188 31.0987 14.346 30.1875C14.514 30.588 14.6806 30.9622 14.8397 31.2877C16.3134 34.3072 15.7882 37.65 15.7829 37.6995C15.7569 37.8564 15.7943 38.0172 15.8869 38.1466C15.9794 38.276 16.1197 38.3634 16.2767 38.3895C16.3097 38.3948 16.343 38.3976 16.3765 38.3977C16.5185 38.3975 16.6558 38.347 16.7641 38.2551C16.8723 38.1632 16.9445 38.036 16.9677 37.896C16.9925 37.746 17.568 34.1407 15.9232 30.765C14.9815 28.8345 13.8552 25.3567 13.7742 24.9097ZM13.7742 24.9562C13.7742 24.9442 13.7742 24.9322 13.7742 24.9195C13.7756 24.9317 13.7763 24.9439 13.7764 24.9562H13.7742Z",
    fill: "#536479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0031 28.4107C35.6034 26.7847 36.0821 25.2315 36.0821 24.9562C36.0852 24.8774 36.0727 24.7988 36.0453 24.7248C36.018 24.6509 35.9763 24.583 35.9227 24.5251C35.8692 24.4673 35.8047 24.4205 35.733 24.3875C35.6614 24.3546 35.5839 24.336 35.5051 24.333C35.4263 24.3299 35.3476 24.3424 35.2736 24.3697C35.1996 24.3971 35.1317 24.4387 35.0738 24.4923C35.0159 24.5458 34.9691 24.6103 34.9361 24.6819C34.9031 24.7535 34.8846 24.8309 34.8815 24.9097C34.8005 25.3597 33.6742 28.8345 32.7325 30.765C31.0862 34.14 31.6632 37.7445 31.6887 37.896C31.712 38.036 31.7842 38.1632 31.8924 38.2551C32.0007 38.347 32.138 38.3975 32.28 38.3977C32.3132 38.3975 32.3463 38.3948 32.3791 38.3895C32.4569 38.3765 32.5314 38.3484 32.5983 38.3067C32.6653 38.265 32.7233 38.2105 32.7692 38.1464C32.815 38.0822 32.8478 38.0097 32.8656 37.9328C32.8833 37.856 32.8858 37.7765 32.8728 37.6987C32.8668 37.665 32.3318 34.3237 33.8115 31.2907C33.9706 30.9652 34.1372 30.591 34.3053 30.1905C34.6324 31.104 35.1164 32.2545 35.7632 33.2767C35.8054 33.3433 35.8603 33.4009 35.9247 33.4463C35.9892 33.4917 36.062 33.5239 36.1389 33.5412C36.2158 33.5585 36.2954 33.5604 36.3731 33.547C36.4507 33.5335 36.525 33.5049 36.5916 33.4627C36.6582 33.4206 36.7159 33.3657 36.7613 33.3013C36.8067 33.2369 36.839 33.1641 36.8562 33.0872C36.8735 33.0104 36.8755 32.9308 36.862 32.8532C36.8485 32.7755 36.8199 32.7013 36.7777 32.6347C35.7647 31.032 35.1659 29.007 35.0031 28.4107ZM34.8823 24.9202C34.8823 24.9322 34.8823 24.9442 34.8823 24.9562C34.8816 24.9442 34.8816 24.9322 34.8823 24.9202Z",
    fill: "#536479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1921 27C24.0329 27 23.8802 27.0632 23.7676 27.1757C23.655 27.2883 23.5918 27.4409 23.5918 27.6V37.8C23.5918 37.9591 23.655 38.1117 23.7676 38.2243C23.8802 38.3368 24.0329 38.4 24.1921 38.4C24.3513 38.4 24.504 38.3368 24.6166 38.2243C24.7291 38.1117 24.7924 37.9591 24.7924 37.8V27.6C24.7924 27.4409 24.7291 27.2883 24.6166 27.1757C24.504 27.0632 24.3513 27 24.1921 27Z",
    fill: "#536479"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaShoulder);
export default __webpack_public_path__ + "static/media/ja_shoulder.ef6494360b20970a0f4c458f93962cf8.svg";
export { ForwardRef as ReactComponent };